import { format } from "date-fns";

import { type CandidateTimelineEntry } from "../api";
import { Utility } from "./utility";

export interface ShortMessage extends CandidateTimelineEntry {}

export class ShortMessage extends Utility<ShortMessage> {
  constructor(init?: Partial<CandidateTimelineEntry>) {
    super();
    Object.assign(this, init);
  }

  get is_not_delivered(): boolean {
    return this.status === "failed" || this.status === "undelivered";
  }

  // Synthesized inbound-call entry merged into the timeline (not a real SMS).
  get is_call_event(): boolean {
    return (
      this.event_kind === "inbound_call" ||
      this.event_kind === "inbound_call_system_error"
    );
  }

  // Body text for a synthesized call event — owned by the frontend so non-English orgs
  // can localize. Returns empty string for non-call-event entries (which render `body`).
  get call_event_label(): string {
    if (this.event_kind === "inbound_call") {
      return "📞 Inbound call received. Connecting to screening agent.";
    }
    if (this.event_kind === "inbound_call_system_error") {
      return "📞 Inbound call could not be connected due to a system error.";
    }
    return "";
  }

  get local_created_at(): Date | undefined {
    if (this.created_at === undefined) return undefined;
    return this.get_local_time(this.created_at);
  }

  get local_created_at_datetime_string(): string | undefined {
    if (this.local_created_at === undefined) return undefined;
    return format(this.local_created_at, "MMM d, hh:mm aaa");
  }

  get local_created_at_date_string(): string | undefined {
    if (this.local_created_at === undefined) return undefined;
    return format(this.local_created_at, "MMM d, yyyy");
  }

  get local_created_at_time_string(): string | undefined {
    if (this.local_created_at === undefined) return undefined;
    return format(this.local_created_at, "hh:mm aaa");
  }
}
